import { ListingBuyerSearchResultModel } from '@steelbuy/ts-shared';

import { createSearchDataContext } from '../../util/provider/SearchDataProvider';

export const ListingBuyerSearchData = createSearchDataContext<ListingBuyerSearchResultModel>();
